import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { Login } from '../Login';
import { Main } from '../Main';
import { ForgotPassword } from '../ForgotPassword';
import { ResetPassword } from '../ResetPassword';
import { PrivateRoute } from '../PrivateRoute';
import { UserRegistration } from '../UserRegistration';
import './App.less';

const Authenticated = () => <Main />;

export const App = () => {
  return (
    <div className="app">
      <Switch>
        <Route exact path="/login" component={Login} />
        <Route exact path="/signup" component={UserRegistration} />
        <Route exact path="/forgot-password" component={ForgotPassword} />
        <Route exact path="/forgot-password/:hash/:token" component={ResetPassword} />
        <PrivateRoute component={Authenticated} />
      </Switch>
    </div>
  );
};
